// services/api/chatbot/chatbot.hooks.ts
import { useAuth } from "@/src/contexts/auth.context";
import { ChatbotConfig } from "@/src/models/chatbot.model";
import { useQuery } from "@tanstack/react-query";
import gqlClient from "../graphql.client";
import { GET_ORG_CHATBOT_CONFIG } from "./chatbot.query";

/**
 * The org's chatbot wiring, stored on its organization config in the data
 * gateway. Read-only by design — the agent and its knowledge-base folder are
 * provisioned per org in the Blocks console, not by this app (see `useChatbot`).
 */
export const useGetChatbotConfig = () => {
  const { orgId } = useAuth();
  return useQuery<ChatbotConfig | null>({
    queryKey: ["chatbotConfig", orgId],
    queryFn: async () => {
      if (!orgId) throw new Error("orgId is required");

      const client = await gqlClient();
      const result = await client.request(GET_ORG_CHATBOT_CONFIG, {
        orgId: orgId!,
      });
      return result.getorganizationconfigs?.items?.[0]?.chatbotConfig ?? null;
    },
    enabled: !!orgId,
  });
};
